import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    console.log('Form submitted:', formData);
    setSuccessMessage('Your message has been sent successfully!');
    setFormData({ name: '', email: '', message: '' });
    setErrors({});
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="contact-box">
          <h1>Get in Touch</h1>
            <strong>Phone:</strong> 
            <a href="tel:+1234567890"> +1 (234) 567-890</a>
          <p>
            <strong>Email:</strong> 
            <a href="mailto:example@example.com"> example@example.com</a>
          </p>
          <p>
            <strong>Facebook:</strong> 
            <a href="https://www.facebook.com/yourprofile" target="_blank" rel="noopener noreferrer"> Send a Message</a>
          </p>
          <p>
            <strong>Instagram:</strong> 
            <a href="https://www.instagram.com/yourprofile" target="_blank" rel="noopener noreferrer"> Send a Message</a>
          </p>
          <p>
            <strong>Telegram:</strong> 
            <a href="https://t.me/yourprofile" target="_blank" rel="noopener noreferrer"> Send a Message</a>
          </p>

          <h2>Send Us a Message</h2>
          {successMessage && <p className="success-message">{successMessage}</p>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
              {errors.message && <span className="error">{errors.message}</span>}
            </div>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact; 